import React from 'react'
import { Link } from 'react-router-dom'
import { FaGoogle,FaInstagram,FaYoutube,FaWhatsapp } from "react-icons/fa";
const Footer = () => {
  return (
    <div>
      <div class='footer-footer p-4'>
        <div class='container'>
        <div class='row'>
          <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-4'>
            <Link to='/' class='text-decoration-none'>
            <img src='./Images/logo1.jpeg' alt='' height={50} width={50} class='footer-img' />
            </Link>
            <p class='w-100 footer-p mt-3 ms-2'>RJ Engineering Fire Protection Safety is dedicated to providing reliable fire safety solutions to protect lives and property. The company offers services such as installation and maintenance of fire alarms, sprinkler systems, fire extinguishers, and other fire protection equipment. With a focus on quality, safety standards, and professional service, RJ Engineering ensures effective fire prevention and emergency preparedness for industries, commercial buildings, and residential areas.</p>
            <Link to='https://www.instagram.com/' >
            <FaInstagram class='text-decoration-none ms-3  icon12'/>
            </Link>
            <Link to='https://youtube.com/'>
            <FaYoutube class='ms-3  icon12'/>
            </Link>
            <Link to='https://wa.me/'>
            <FaWhatsapp class='ms-3  icon12'/>
            </Link>
            <Link to='https://share.google/'>
            <FaGoogle class='ms-3  icon12'/>
            </Link>
          </div>
          <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-4'>
            <h4 class='footer-h4'>Our Services</h4>
            <hr class='footer-divider' />
            <Link class='text-decoration-none' to={'/Annual'} >
            <h6 class='footer-head'>Annual Maintenance Works</h6>
            </Link>
            <Link class='text-decoration-none' to={'/Hydrant'}>
            <h6 class='footer-head'>Fire Hydrant Works</h6>
            </Link>
            <Link class='text-decoration-none' to={'/Alarm'}>
            <h6 class='footer-head'>Fire Alarm & Security System Works</h6>
            </Link>
            <Link class='text-decoration-none' to={'/Plumbing'}>
            <h6 class='footer-head'>Plumbing Works</h6>
            </Link>
            <Link class='text-decoration-none' to={'/Hvac'}>
            <h6 class='footer-head'>HVAC Works</h6>
            </Link>
            <Link class='text-decoration-none' to={'/Electrical'}>
            <h6 class='footer-head'>Electrical Works</h6>
            </Link>
          </div>
          <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-4'>
            <h4 class='footer-h4'>ADDRESS</h4>
            <hr class='footer-divider' />
            <p class='footer-p'>RJ ENGINEERING<br></br><br></br>First floor,Site no 46,Drishrik plaza,Neralur,<br></br>Attibele Hobli,Anekal Taluk,<br></br> Bangalore 562107</p>
            <h4 class='footer-h'>Mob :</h4>
            <p class='footer-p'>+91 9606577402</p>
            <h4 class='footer-h'>Email :</h4>
            <p class='footer-p'>rajeshsebastian@rjengineering.org</p>
            <p class='footer-p'>office@rjengineering.org</p>
          </div>
          
        </div>
        <div class='row'>
          <div class='col footer-2  mt-3 ms-3'>
          <p>Copyrights © 2026 RjEngineering. All Rights Reserved</p>
          </div>
        </div>
        </div>
      </div>
    </div>
    )
}

export default Footer